module.exports = __webpack_public_path__ + "img/Logo_ZWING offline.65058ede.svg";